import {
    Component,
    OnInit,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    AfterViewInit,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ElementRef,
    ViewChild
  } from '@angular/core';
 
  
  import {Observable, pipe, throwError, Subscription} from 'rxjs'; 
  
  declare var $: any;

  import {MessageService} from '../message.service';
  
  @Component({
    selector: 'open_layout',
    templateUrl: './open_layout.component.html',
    encapsulation: ViewEncapsulation.None,
  })
  export class Layout1Component  implements OnDestroy {

    msgSubscribe:Subscription;

    user:any;
  
   
    constructor(private msg:MessageService){

      this.msgSubscribe=   this.msg.getMessage().subscribe( (evt) => {



        if(evt!=undefined){

           
         switch(evt.text.type){
           
           case 'open_layout_user':
           

           this.user =evt.text.user ;

           break;



         }

        }


});


    }


    ngOnDestroy() {

      this.msgSubscribe.unsubscribe();
      
  
  }
    
    
  }